import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'

/**
 * Modal to confirm the moving to ready to submit of an OCR scoped job.
 */
export default class OCRConfirmReviewModalViewModel extends ModalViewModel {
  constructor(
    private readonly onConfirm: () => unknown,
    closingSignal?: ModalViewModelClosingSignal
  ) {
    super(closingSignal)
  }

  confirm = () => {
    this.onConfirm()
    this.close()
  }
}
